/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AQ as AQ,
  rec_ArmarOrden as ArmarOrden,
  rec_Bo as Bo,
  rec_Componente_FQ_70_81 as Componente_FQ_70_81,
  rec_Componente__Dolar_95_36 as Componente__Dolar_95_36,
  rec_Componente_vDolar_118_36 as Componente_vDolar_118_36,
  rec_EstadoError as EstadoError,
  rec_Go as Go,
  rec_JSXRuntime as JSXRuntime,
  rec_Lo as Lo,
  rec_MarcaCarga as MarcaCarga,
  rec_PQ as PQ,
  rec_React as React,
  rec_Ro as Ro,
  rec_SelectorFecha as SelectorFecha,
  rec_api as api,
  rec_es as es,
  rec_fC as fC,
  rec_jQ as jQ,
  rec_kQ as kQ,
  rec_zo as zo,
} from "../../runtime/index.jsx";
/** Tope de personas de un grupo sugerido y colores para distinguirlos (sin rosados). */
const MAXIMO_GRUPO = 50;
const COLORES_GRUPO = [`#2f7fb8`, `#3f9b5f`, `#c98a1a`, `#7b61c9`, `#1f9aa8`, `#d0662b`, `#6d8f1f`, `#4b5fc4`];

export function PedidosTransporte() {
  let e = Go(),
    [t, n] = (0, React.useState)(() => AQ(1)),
    [r, i] = (0, React.useState)(kQ),
    [a, o] = (0, React.useState)([]),
    [s, c] = (0, React.useState)([]),
    [l, u] = (0, React.useState)([]),
    [f, p] = (0, React.useState)([]),
    [m, h] = (0, React.useState)(``),
    [g, _] = (0, React.useState)({}),
    [v, y] = (0, React.useState)(!0),
    [b, x] = (0, React.useState)(``),
    [S, C] = (0, React.useState)(!1),
    w = (0, React.useCallback)(async () => {
      y(!0);
      try {
        let [e, n, i] = await Promise.all([
          api(`/transporte/por-atender?desde=${t}&hasta=${r}`),
          api(`/transporte/unidades`),
          api(`/transporte/proveedores`),
        ]);
        (o(e),
          c(n.filter((e) => e.activo)),
          u(i.filter((e) => e.activo)),
          p([]),
          x(``));
      } catch (e) {
        x(e.message);
      } finally {
        y(!1);
      }
    }, [t, r]);
  (0, React.useEffect)(() => {
    w();
  }, [w]);
  let T = (0, React.useCallback)(async () => {
    try {
      let e = await api(`/transporte/por-atender?desde=${t}&hasta=${r}`);
      return (o(e), p((t) => t.filter((t) => e.some((e) => e.id === t))), e);
    } catch {
      return null;
    }
  }, [t, r]);
  (0, React.useEffect)(
    () =>
      fC(
        async () => {
          (await T()) && (es(`carro`), e.info(`Entró un pedido nuevo`));
        },
        {
          entidad: `PEDIDO_MOVILIDAD`,
        },
      ),
    [T, e],
  );
  let E = (0, React.useMemo)(() => {
      let e = m.trim().toLowerCase(),
        t = (
          e
            ? a.filter((t) =>
                [t.destino, t.sede, t.area, t.solicitante, t.salida, t.codigo]
                  .filter(Boolean)
                  .some((t) => t.toLowerCase().includes(e)),
              )
            : a
        ).filter((e) =>
          PQ.every(({ id: t, campo: n }) => {
            let r = g[t];
            return !r || String(n(e) ?? ``) === r;
          }),
        ),
        n = new Map();
      // Grupos sugeridos: por fecha + salida + fundo + RUTA (2026-10-08), de
      // hasta MAXIMO_GRUPO personas; dentro, en el orden de la ruta, así una
      // unidad va dejando gente parada por parada.
      for (let e of t) {
        let t = `${e.fecha}|${e.salida}|${(e.sede || ``).trim().toLowerCase()}|${e.ruta || ``}`;
        (n.has(t) || n.set(t, { fecha: e.fecha, salida: e.salida, sede: e.sede, ruta: e.ruta || null, pedidos: [] }), n.get(t).pedidos.push(e));
      }
      let grupos = [];
      for (let [clave, base] of n) {
        let orden = [...base.pedidos].sort((a, b) => (a.destinoOrden ?? 1e9) - (b.destinoOrden ?? 1e9) || String(a.destino).localeCompare(String(b.destino), `es`) || (b.personas || 0) - (a.personas || 0)),
          actual = null;
        for (let pedido of orden) {
          let p = pedido.personas || 0;
          if (!actual || actual.personas + p > MAXIMO_GRUPO) {
            actual = { clave: `${clave}|${grupos.length}`, fecha: base.fecha, salida: base.salida, sede: base.sede, ruta: base.ruta, pedidos: [], personas: 0 };
            grupos.push(actual);
          }
          actual.pedidos.push(pedido);
          actual.personas += p;
        }
      }
      return grupos
        .sort((a, b) => String(a.fecha).localeCompare(String(b.fecha)) || String(a.salida).localeCompare(String(b.salida)) || String(a.sede).localeCompare(String(b.sede), `es`) || String(a.ruta ?? `~`).localeCompare(String(b.ruta ?? `~`), `es`))
        .map((e, i) => ({ ...e, numero: i + 1, color: COLORES_GRUPO[i % COLORES_GRUPO.length], destinos: [...new Set(e.pedidos.map((x) => x.destino))] }));
    }, [a, m, g]),
    D = (0, React.useMemo)(() => {
      let e = {};
      for (let { id: t, campo: n } of PQ)
        e[t] = [...new Set(a.map((e) => n(e)).filter(Boolean))].sort((e, t) =>
          String(e).localeCompare(String(t), `es`),
        );
      return e;
    }, [a]),
    O = Object.values(g).filter(Boolean).length,
    k = (e) => ({
      etiqueta: PQ.find((t) => t.id === e).etiqueta,
      opciones: D[e] ?? [],
      valor: g[e] ?? ``,
      onChange: (t) =>
        _((n) => ({
          ...n,
          [e]: t,
        })),
    }),
    A = a.reduce((e, t) => e + (t.personas || 0), 0),
    j = (0, React.useMemo)(() => a.filter((e) => f.includes(e.id)), [a, f]),
    M = j.reduce((e, t) => e + (t.personas || 0), 0);
  function N(e) {
    p((t) => (t.includes(e) ? t.filter((t) => t !== e) : [...t, e]));
  }
  function P(e) {
    let t = e.pedidos.map((e) => e.id),
      n = t.every((e) => f.includes(e));
    p((e) =>
      n ? e.filter((e) => !t.includes(e)) : [...new Set([...e, ...t])],
    );
  }
  return (
    <div
      className={`flex flex-col gap-4`}
      children={[
        <EstadoError mensaje={b} onReintentar={w} />,
        <section
          className={`${Bo} flex flex-wrap items-end gap-3`}
          children={[
            <label
              className={`flex flex-col gap-1 text-sm text-(--text)`}
              children={[
                `Desde`,
                <SelectorFecha value={t} onChange={n} max={r} />,
              ]}
            />,
            <label
              className={`flex flex-col gap-1 text-sm text-(--text)`}
              children={[
                `Hasta`,
                <SelectorFecha value={r} onChange={i} min={t} />,
              ]}
            />,
            <input
              type={`search`}
              value={m}
              onChange={(e) => h(e.target.value)}
              placeholder={`Filtrar por destino, fundo, área o persona`}
              className={`${Lo} min-w-60 flex-1`}
            />,
            <p
              className={`text-sm text-(--text)`}
              children={[a.length, ` sin asignar · `, A, ` personas`]}
            />,
            O > 0 && (
              <button
                type={`button`}
                onClick={() => _({})}
                className={`rounded-lg border border-(--accent-border) px-2 py-1 text-xs text-(--accent)`}
                children={[`Quitar `, O, ` `, O === 1 ? `filtro` : `filtros`]}
              />
            ),
          ]}
        />,
        v ? (
          <Componente__Dolar_95_36 />
        ) : b ? null : E.length === 0 ? (
          <Componente_vDolar_118_36
            texto={
              a.length === 0
                ? `No hay pedidos esperando. Todo lo que entró ya está en una orden.`
                : `Ninguno coincide con lo que buscaste.`
            }
          />
        ) : (
          <div
            className={`${Bo} overflow-x-auto p-0`}
            children={
              <table
                className={`w-full text-left text-sm`}
                children={[
                  <thead
                    className={`sticky top-0 bg-(--bg) text-xs text-(--text)`}
                    children={
                      <tr
                        className={`border-b border-(--border)`}
                        children={[
                          <th className={`w-8 py-2 pl-3`} />,
                          <th
                            className={`py-2 pr-3 font-medium`}
                            children={[
                              `Salida `,
                              <Componente_FQ_70_81 {...k(`salida`)} />,
                            ]}
                          />,
                          <th
                            className={`py-2 pr-3 font-medium`}
                            children={[
                              `Destino `,
                              <Componente_FQ_70_81 {...k(`destino`)} />,
                            ]}
                          />,
                          <th
                            className={`py-2 pr-3 font-medium`}
                            children={`Pers.`}
                          />,
                          <th
                            className={`py-2 pr-3 font-medium`}
                            children={[
                              `Fundo `,
                              <Componente_FQ_70_81 {...k(`sede`)} />,
                            ]}
                          />,
                          <th
                            className={`py-2 pr-3 font-medium`}
                            children={[
                              `Área `,
                              <Componente_FQ_70_81 {...k(`area`)} />,
                            ]}
                          />,
                          <th
                            className={`py-2 pr-3 font-medium`}
                            children={[
                              `Lo pidió `,
                              <Componente_FQ_70_81 {...k(`solicitante`)} />,
                            ]}
                          />,
                          <th
                            className={`py-2 pr-3 font-medium`}
                            children={`Fecha`}
                          />,
                          <th className={`w-24 py-2 pr-3`} />,
                        ]}
                      />
                    }
                  />,
                  E.map((e) => (
                    <tbody
                      key={e.clave}
                      className={`border-b border-(--border) last:border-0`}
                      style={{ boxShadow: `inset 4px 0 0 ${e.color}` }}
                      children={[
                        <tr key={`cab`} style={{ background: `color-mix(in srgb, ${e.color} 12%, transparent)` }}>
                          <td colSpan={9} className={`px-3 py-1.5 text-xs`}>
                            <div className={`flex flex-wrap items-center gap-2`}>
                              <span className={`rounded-full px-2 py-0.5 font-semibold text-white`} style={{ background: e.color }}>Grupo {e.numero}</span>
                              <span className={`font-medium text-(--text-h)`}>{e.salida} · {e.sede}</span>
                              <span className={`font-medium`} style={{ color: e.color }}>{e.ruta ?? `Sin ruta`}</span>
                              <span className={`text-(--text)`}>{e.destinos.join(` → `)} · {e.personas} personas · {e.pedidos.length} {e.pedidos.length === 1 ? `pedido` : `pedidos`}</span>
                              {e.personas > MAXIMO_GRUPO && <span className={`text-(--error)`}>Un solo pedido pasa de {MAXIMO_GRUPO}</span>}
                              <button type={`button`} onClick={() => P(e)} className={`ml-auto rounded-full border border-(--border) bg-(--bg) px-2.5 py-0.5 text-(--text-h) hover:border-(--accent) hover:text-(--accent)`}>
                                {e.pedidos.every((x) => f.includes(x.id)) ? `Quitar el grupo` : `Elegir el grupo`}
                              </button>
                            </div>
                          </td>
                        </tr>,
                        ...e.pedidos.map((t, n) => (
                        <tr
                          key={t.id}
                          onClick={() => N(t.id)}
                          className={`group cursor-pointer border-t border-(--border)/50 transition ${f.includes(t.id) ? `bg-(--accent-bg)` : `hover:bg-(--panel)`}`}
                          children={[
                            <td
                              className={`py-1.5 pl-3`}
                              onClick={(e) => e.stopPropagation()}
                              children={
                                <MarcaCarga
                                  checked={f.includes(t.id)}
                                  onChange={() => N(t.id)}
                                />
                              }
                            />,
                            <td
                              className={`py-1.5 pr-3 whitespace-nowrap font-medium text-(--text-h)`}
                              children={t.salida}
                            />,
                            <td
                              className={`py-1.5 pr-3 text-(--text-h)`}
                              children={t.destino}
                            />,
                            <td
                              className={`py-1.5 pr-3 text-(--text-h)`}
                              children={t.personas}
                            />,
                            <td
                              className={`py-1.5 pr-3 text-(--text)`}
                              children={t.sede}
                            />,
                            <td
                              className={`py-1.5 pr-3 text-(--text)`}
                              children={t.area || `—`}
                            />,
                            <td
                              className={`py-1.5 pr-3 text-(--text)`}
                              children={t.solicitante}
                            />,
                            <td
                              className={`py-1.5 pr-3 whitespace-nowrap text-(--text)`}
                              children={jQ(t.fecha)}
                            />,
                            <td
                              className={`py-1.5 pr-3`}
                              onClick={(e) => e.stopPropagation()}
                              children={
                                null
                              }
                            />,
                          ]}
                        />
                      )),
                      ]}
                    />
                  )),
                ]}
              />
            }
          />
        ),
        f.length > 0 && (
          <div
            className={`animar-entrada sticky bottom-0 flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-(--accent-border) bg-(--bg) p-3 shadow-lg`}
            children={[
              <p
                className={`text-sm text-(--text-h)`}
                children={[
                  f.length,
                  ` `,
                  f.length === 1 ? `pedido` : `pedidos`,
                  ` · `,
                  M,
                  ` `,
                  `personas`,
                ]}
              />,
              <div
                className={`flex gap-2`}
                children={[
                  <button
                    type={`button`}
                    onClick={() => p([])}
                    className={zo}
                    children={`Limpiar`}
                  />,
                  <button
                    type={`button`}
                    onClick={() => C(!0)}
                    className={Ro}
                    children={`Armar orden`}
                  />,
                ]}
              />,
            ]}
          />
        ),
        S && (
          <ArmarOrden
            pedidos={j}
            personas={M}
            unidades={s}
            proveedores={l}
            onClose={() => C(!1)}
            onCreada={(t) => {
              (C(!1), e.logro(`Orden armada`, t.codigo), w());
            }}
          />
        ),
      ]}
    />
  );
}
